import { useSiteData } from "@/context/SiteDataContext";
import { effectiveImageFit, mergeBenefitsSection } from "@/lib/benefitsSectionConfig";

export default function Benefits() {
  const { data } = useSiteData();
  const beneficios = data.contentBlocks.home?.benefits ?? [];
  const stats = data.contentBlocks.home?.stats ?? [];
  const section = mergeBenefitsSection(data.contentBlocks.home?.benefits_section?.[0]);

  return (
    <section className="bg-primary-900">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            {section.etiqueta && <span className="text-sm font-semibold text-accent-400">{section.etiqueta}</span>}
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-background-50">{section.titulo}</h2>
            {section.descripcion && (
              <p className="mt-4 text-base md:text-lg text-background-300 leading-relaxed">{section.descripcion}</p>
            )}

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {beneficios.map((item) => (
                <div key={item.id} className="flex gap-3.5">
                  <span className="w-11 h-11 shrink-0 rounded-lg bg-primary-800 text-accent-300 flex items-center justify-center">
                    <i className={`${item.icono} text-xl`} />
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-background-50 text-sm">{item.titulo}</h3>
                    <p className="mt-1 text-sm text-background-300 leading-relaxed">{item.descripcion}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((stat) => (
              <div
                key={stat.id}
                className="rounded-lg bg-primary-800/60 border border-primary-700/50 p-6 text-center"
              >
                <p className="font-heading font-bold text-2xl md:text-3xl text-accent-400">{stat.valor}</p>
                <p className="mt-1 text-xs md:text-sm text-background-300">{stat.etiqueta}</p>
              </div>
            ))}
            {section.imagen_url &&
              (effectiveImageFit(section) === "recortar" ? (
                <div className="col-span-2 rounded-lg overflow-hidden border border-primary-700/50 h-40">
                  <img src={section.imagen_url} alt={section.imagen_alt} className="w-full h-full object-cover object-top" />
                </div>
              ) : (
                <div className="col-span-2 rounded-lg overflow-hidden border border-primary-700/50">
                  <img
                    src={section.imagen_url}
                    alt={section.imagen_alt}
                    className="block w-full h-auto max-h-[28rem] object-contain"
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}